module.exports = __webpack_public_path__ + "img/collection-memoireRingsExclusive@2x.6186272.jpg";